import { problemCards } from "./landingContent";
import { LandingCard, LandingSection } from "./LandingPrimitives";

function ProblemShape({ index }: { index: number }) {
  if (index === 0) {
    return (
      <div className="landing-problem-shape landing-problem-shape--bars" aria-hidden="true">
        <div className="landing-bar landing-bar--short" />
        <div className="landing-bar landing-bar--tall" />
        <div className="landing-bar landing-bar--wide" />
      </div>
    );
  }

  if (index === 1) {
    return (
      <div className="landing-problem-shape landing-problem-shape--alert" aria-hidden="true">
        <div className="landing-alert__line landing-alert__line--base" />
        <div className="landing-alert__line landing-alert__line--stem" />
        <div className="landing-alert__triangle" />
        <div className="landing-alert__badge">!</div>
      </div>
    );
  }

  return (
    <div className="landing-problem-shape landing-problem-shape--clock" aria-hidden="true">
      <div className="landing-clock__ring" />
      <div className="landing-clock__hand landing-clock__hand--short" />
      <div className="landing-clock__hand landing-clock__hand--long" />
      <div className="landing-clock__dot" />
    </div>
  );
}

export default function LandingProblemSection() {
  return (
    <LandingSection
      id="probleme"
      eyebrow="Situații stresante"
      title="De ce firmele caută o aplicație pentru foi de parcurs, nu încă un Excel făcut manual"
      description="Când foile de parcurs pentru firmă lipsesc, rămân în urmă sau sunt completate manual, impactul se vede direct în bani, timp și risc fiscal."
    >
      <div className="landing-problem-grid">
        {problemCards.map((problem, index) => (
          <LandingCard key={problem.title} className="landing-problem-card landing-problem-card--plain" plain>
            <div className={`landing-problem-glow landing-problem-glow--${index}`} aria-hidden="true" />

            <div className="landing-problem-card__top">
              <div className="landing-problem-card__visual">
                <ProblemShape index={index} />
              </div>
              <div className="landing-problem-card__badge">{problem.label}</div>
            </div>

            <div className="landing-problem-card__body">
              <h3>{problem.title}</h3>
              <div className={`landing-problem-card__stat landing-problem-card__stat--${index}`}>
                <p>{problem.stat}</p>
              </div>
            </div>

            <div className="landing-problem-card__divider" />
            <p className="landing-problem-card__description">{problem.description}</p>
          </LandingCard>
        ))}
      </div>
    </LandingSection>
  );
}
